import { Component, ChangeDetectorRef } from '@angular/core';
import { AuthenticationService, TestData } from '../services/authentication.service';
import { TestSchedulerService } from '../services/test_scheduler.service';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { QuestionSetService, QuestionSet } from '../services/questionset.service';
import { Evaluate, EvaluateCheck } from './evaluate.model';
import { Schedule } from '../scheduletest/scheduletest.model';
import { College_Names, CollegeService, evaluate } from '../services/College_name.service';
import { Year, YearService } from '../services/year.service';
import Swal from 'sweetalert2';



@Component({
  templateUrl: './evaluate_marks.component.html',
  styleUrls: [ './evaluate_marks.component.scss' ]
})

export class EvaluateMarksComponent {

  fieldArray: Array<Schedule> = [];
  selectedCategory;
  selectedCategoryindex: string;
  evaluate_details: evaluate = { college_id: '', year_id: '' ,questionset_id:''};
  //fieldArray: Array<Evaluate> = [];
  newAttribute: any = {};
  Question_Category: any;
  result: boolean;
  details: boolean;
  Category;
  Type;
  Complexity;
  complexityId: string;
  fname;
  lname;
  user;
  view: Array<EvaluateCheck> = [];
  isCustomStyleApplied: boolean = false;
  selected: boolean = false;
  userAdmin: boolean;
  overall: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  questionset: boolean;
  scheduletest: boolean;
  mobileQuery: MediaQueryList;

  masterSelected: boolean;
  checkedList: any;

  evaluate: boolean;
  all: boolean;
  candidate: boolean;
  private _mobileQueryListener: () => void;

  question_set: QuestionSet = {
    Question_Set_Name: ''
  };
  college_set: College_Names={
    college_name:''
  }
  year_set: Year={
    academic_year:''
  }

  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  college: any;
  selectedindex: any;
  selectedcollegeset: any;
  screenWidth: number | undefined;
  screenHeight: number | undefined;
  Year: any;
  collegeid: any;
  questionsetid: any;
  yeardid: any;
  yearid: any;
  selectedquestionset: any;
  Pattern: any;
  userEvaluator: boolean;
  constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router, private qs: QuestionSetService,
    private fs:CollegeService,private ys:YearService,
              private testschedulerservice: TestSchedulerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
  this.masterSelected = false;
  this.simpletest();
  //this.evaluation_details();
  this.mobileQuery = media.matchMedia('(max-width: 600px)');
  this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  this.mobileQuery.addListener(this._mobileQueryListener);
  this.Questionset();
  this.CollegeName();
  }

  ngOnInit() {
    this.getTempRowData();
    this.getAccess();
    this.getScreenSize();
    this.applyStylesBasedOnResolution();
  }
  // getAccess() {
  //   throw new Error('Method not implemented.');
  // }
  getScreenSize(): void {
    this.screenWidth = window.innerWidth;
     console.log(" this.screenWidth", this.screenWidth);
    this.screenHeight = window.innerHeight;
    console.log(" this.screenHeight",  this.screenHeight);
  }

  applyStylesBasedOnResolution(): void {
    if (this.screenWidth && this.screenHeight) {
      console.log("custom", this.isCustomStyleApplied)
      if (this.screenWidth < 1366 && this.screenHeight <  641) {
        this.isCustomStyleApplied = true;
        console.log("custom", this.isCustomStyleApplied );
      
      }
     
    }
  }
  getAccess(){
    console.log("Inside the get Access func of test evaluation");
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');

    console.log("FNAME ,LNAME",this.fname,this.lname)
    console.log("USER ID ",this.user);

    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      console.log("CONDITION PASSED");
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;

      console.log("user Evalautor status",this.userEvaluator);
      console.log("user Scheduler status ",this.userTestScheduler);
      console.log("user Admin status ",this.userAdmin);
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }


simpletest() {
this.testschedulerservice.test_scheduler(this.test).subscribe(
(data) => {

this.user = sessionStorage.getItem('user');
this.fname = sessionStorage.getItem('fname');

this.lname = sessionStorage.getItem('lname');


if (this.user === '2') {

this.userAdmin = false;
this.userSuperAdmin = false;
this.userTestScheduler = true;
this.userTestTaker = true;
this.details = true;
this.overall = true;
this.questionset = true;
this.scheduletest = true;
this.evaluate = true;
// this.result = data.results;
return this.result;
} else if ( this.user === '1') {
this.userAdmin = true;
this.userSuperAdmin = true;
this.userTestScheduler = true;
this.userTestTaker = true;
this.questionset = true;
this.details = true;
this.overall = true;
this.evaluate = true;
this.scheduletest = true;
// this.result = data.results;
return this.result;
} else if ( this.user === '3') {
this.userAdmin = false;
this.userSuperAdmin = false;
this.userTestScheduler = false;
this.userTestTaker = true;
this.questionset = true;
this.details = true;
this.overall = true;
this.evaluate = true;
this.scheduletest = true;
} else if ( this.user === '4') {
this.userAdmin = false;
this.userSuperAdmin = false;
this.userTestScheduler = false;
this.userTestTaker = false;
this.questionset = false;
this.details = false;
this.scheduletest = true;
this.overall = false;
this.evaluate = false;
}
},
err => {
console.error(err);
}
);
}

getTempRowData() {
  this.newAttribute = { college_name:'', academic_year:'', questionsetname: '', pattern: '', date: '', start_time: '', end_time:'', paperlist: '', scheduler: ''};

  this.fieldArray.push(this.newAttribute);
}

Questionset() {
  this.qs.question_set_display(this.question_set).subscribe(
    (data) => {

      this.result = data.results;
      //this.questionsetid=this.result[0].Id


    },
    err => {
      console.error(err);
    }
  );

  // this.testtakerservice.test_taker(this.test).subscribe(
  //   (data) => {
  //
  //    this.result1 = data.results;
  //
  //

  //   }
  //);
}





// evaluation_details() {
//
//   this.qs.evaluation_details(this.fieldArray).subscribe(
//     (data) => {
//
//       this.view = data.results;
//
//       //
//     },
//     err => {
//       console.error(err);
//     }
//   );
//   }

selectChangeHandler(event: any, i: any) {

  this.selectedindex = i;

  this.selectedquestionset = event.target.value;

  this.questionsetid=this.selectedquestionset;
  this.qs.pattern(this.selectedquestionset).subscribe(
           (data) => {

            this.Pattern = data.results;
            this.fieldArray[i].paperlist = data.results;


            this.questionsetid=this.selectedquestionset
           },
                 err => {
                   console.error(err);
                 }
           );
   }

  checkUncheckAll() {
    for (var i = 0; i < this.view.length; i++) {
      this.view[i].selected = this.masterSelected;
    }

    this.getCheckedItemList();
  }
  isAllSelected() {
    this.masterSelected = this.view.every( function(item: any) {
        return item.selected === true;
      });
    this.getCheckedItemList();
  }
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.view.length; i++) {
      if (this.view[i].selected) {
        this.checkedList.push(this.view[i]);
      }
    }


    if (this.checkedList.length >= 1 ) {
      this.all = true;
    } else if ( this.checkedList.length === 0 ) {
      this.all = false;
    }
  }

  selectChangeHandler1(event: any, i: any) {

    this.selectedindex = i;

    this.selectedcollegeset = event.target.value;

    this.collegeid=this.selectedcollegeset;

    this.ys.academicyear(this.selectedcollegeset).subscribe(
             (data) => {

              this.Year = data.results;
              this.fieldArray[i].academic_year = data.results;


              this.yearid=this.Year[0].Id
             },
                   err => {
                     console.error(err);
                   }
             );
     }

     CollegeName() {
      this.fs.College_Name(this.college_set).subscribe(
        (data) => {

          this.college = data.results;


        },
        err => {
          console.error(err);
        }
      );

      // this.testtakerservice.test_taker(this.test).subscribe(
      //   (data) => {
      //
      //    this.result1 = data.results;
      //
      //

      //   }
      // );
    }


 evaluate_all() {
  // prepare the request body
  this.evaluate_details.college_id = this.collegeid;
  this.evaluate_details.questionset_id = this.questionsetid;
  this.evaluate_details.year_id = this.yearid;
  this.qs.evaluate_all(this.evaluate_details).subscribe(
    (data) => {
      // Handle 202: Async job started
      if (data.code === 202) {
        Swal.fire({
          title: 'Evaluation Started',
          html: `
            <p><strong>MCQ Evaluation:</strong> ${data.mcq_evaluation}</p>
            <p><strong>Free Text Evaluation:</strong> Started in background</p>
            <p><strong>Students:</strong> ${data.freetext_evaluation?.students_count || 0}</p>
            <br>
            <p>The evaluation is running in the background. You will be notified when complete.</p>
          `,
          icon: 'success',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            // User can continue working
            // Optionally navigate away or refresh data later
          }
        });
      }
      // Handle 200: Synchronous success or no students to evaluate
      else if (data.code === 200) {
        let message = data.success || 'Evaluation completed successfully!';
        let icon: 'success' | 'warning' | 'info' = 'success';
        
        // Check if free text was skipped (no students to evaluate)
        if (data.freetext_evaluation?.status === 'skipped') {
          message = `<p>${data.success}</p><p><em>${data.freetext_evaluation.reason}</em></p>`;
          icon = 'info';
        }
        // Check if free text failed but MCQ succeeded
        else if (data.freetext_evaluation?.status === 'failed') {
          message = `
            <p><strong>MCQ Evaluation:</strong> Completed ✓</p>
            <p><strong>Free Text Evaluation:</strong> Failed ✗</p>
            <p><em>Error: ${data.freetext_evaluation.error}</em></p>
          `;
          icon = 'warning';
        }
        
        Swal.fire({
          title: icon === 'warning' ? 'Partially Completed' : 'Success',
          html: message,
          icon: icon,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            // Optionally refresh data or navigate
          }
        });
      }
      // Handle errors (400+)
      else {
        Swal.fire({
          title: 'Failed',
          text: data.failed || data.error || 'Evaluation failed',
          icon: 'warning',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            // Handle error scenario
          }
        });
      }
    },
    err => {
      console.error('Error in evaluation:', err);
      Swal.fire({
        title: 'Error',
        text: 'An unexpected error occurred during evaluation.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  );
}
// evaluatecandidate(row, set) {
//
//
//   var arr: Evaluate = {
//     test_taker_id: row,
//     schedule_id: set
//   };
//   this.fieldArray.push(arr);
//
//   this.qs.evaluate_marks(this.fieldArray).subscribe(
//     (data) => {
//       if (data.code === 200) {
//         alert(data.success);
//       } else {
//
//       alert(data.failed);
//     }
//     },
//     err => {
//       console.error(err);
//     }
//   );
// }
}
